import { trimPathEnd, trimPathStart } from './trimPath';

export function concatPath(a: string, b: string) {
    if (a === '/') {
        return b;
    }

    return [trimPathEnd(a), trimPathStart(b)].join('/');
}
